import * as React from 'react';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectGamesByProviderAndCategory, selectGamesLoading } from '@/store/games/selectors';
import CategoryPageContent from '@/pages/games/categories/CategoryPageContent';
import EmptyGamesPlaceholder from '@/pages/games/EmptyGamesPlaceholder';
import { BffGamesCategory } from '@lucky7ventures/bff-types';
import GamesByProviderSkeletonLoader from '@/components/shared/skeleton-loader/GamesByProviderSkeletonLoader';
import ProviderGamesLayout from '@/pages/games/providers/ProviderGamesLayout';

function GamesByProviderCategory(): JSX.Element {
  const { provider, category } = useParams<{ provider?: string; category?: string }>();

  const validCategory = Object.values(BffGamesCategory).includes(category as BffGamesCategory)
    ? (category as BffGamesCategory)
    : undefined;

  const selectedProvider = useSelector(selectGamesByProviderAndCategory(provider, validCategory));
  const gamesLoading = useSelector(selectGamesLoading);

  if (gamesLoading) {
    return <GamesByProviderSkeletonLoader />;
  }

  if (!provider || !selectedProvider || !validCategory) {
    return <EmptyGamesPlaceholder category={BffGamesCategory.AllGames} />;
  }

  return (
    <ProviderGamesLayout provider={provider}>
      <CategoryPageContent
        category={validCategory}
        games={selectedProvider.games}
        loading={gamesLoading}
      />
    </ProviderGamesLayout>
  );
}

export default GamesByProviderCategory;
